<app-common-announcement [announcementMessage]="announcementData"></app-common-announcement>
<nav class="navbar">
    <div class="container-fluid display-profile-header pl-20 pr-20 align-items-center">
        <div class="d-flex" appFocus appClick>
            <!-- <i  class="bi bi-list"></i> -->
            <!-- <img alt=""  *ngIf="this.schoolProps.properties.job_only_school" class="logo-image" src="assets/images/side-nav/fav_img.png"> -->
            <img alt="" *ngIf="this.schoolProps.properties.job_only_school" class="side_logo_text d-show-350"
                src="assets/images/side-nav/CCJobsWhite.png" />
            <img alt="" *ngIf="this.schoolProps.properties.job_only_school" class="fav_logo d-none-350"
                src="assets/images/side-nav/fav_img.png" />
            <img alt="" *ngIf="!this.schoolProps.properties.job_only_school" class="side_logo_text_booking d-show-350"
                src="assets/images/favicon/CCLogo.png" />
            <img alt="" *ngIf="!this.schoolProps.properties.job_only_school" class="fav_logo d-none-350"
                src="assets/images/favicon/fav_icon_new.png" />
            <!-- <input type="text" placeholder="Search" class="form-control ml-20"> -->
        </div>
        <div class="nav-item list-unstyled d-flex align-items-center">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle px-0" href="#" id="navbarDropdown" role="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="mr-10">{{ schoolProps.properties.group_name }} <svg xmlns="http://www.w3.org/2000/svg"
                            width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                        </svg>
                    </span>
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <!-- <li><a class="dropdown-item">{{this.schoolProps.mixpanel_data.school_name}}</a></li> -->
                    <li>
                        <a class="dropdown-item" routerLink="/co-ordinator/settings" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">Settings</a>
                    </li>
                    <li *ngIf="from_page_cookie == 'loginas'">
                        <a class="dropdown-item" (click)="backToAdmin()">Back to admin</a>
                    </li>
                    <li *ngIf="from_page_cookie == 'loginas_group'">
                        <a class="dropdown-item" (click)="backToGroup()">Back to Group</a>
                    </li>
                    <!-- <li><a class="dropdown-item">{{this.schoolProps.mixpanel_data.name}}</a></li> -->
                    <li>
                        <a class="dropdown-item" (click)="logout()">Logout</a>
                    </li>
                    <!-- <li><a class="dropdown-item">Switch to old ClassCover Website</a></li> -->
                </ul>
            </li>
            <!-- <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle px-0" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          <span class="mr-10">{{ schoolProps.properties.group_name }}</span>
        </a>
      </li> -->
        </div>

        <!-- <p class="nav-link HideOnRes plan-badge" *ngIf="this.schoolProps.properties.job_only_school">
            {{plan}}
        </p> -->
    </div>
</nav>